export const compactPrice = (value) => {
  const amount = Number(value) || 0;
  if (amount >= 1000000 || Math.round(amount / 1000) >= 1000) {
    const millions = amount / 1000000;
    return `$${Number.isInteger(millions) ? millions : millions.toFixed(1).replace(/\.0$/, "")}M`;
  }
  if (amount >= 1000) return `$${Math.round(amount / 1000)}K`;
  return `$${amount}`;
};
